<template>
  <section class="register-container">
    <div class="register-card">
      <h1 class="form-title">{{ $t('resetPassword.title') }}</h1>

      <form class="register-form" @submit.prevent="submit">
        <label for="newPassword">{{ $t('resetPassword.label') }}</label>
        <input
          id="newPassword"
          v-model="newPassword"
          type="password"
          required
        />

        <button class="btn" :disabled="loading">
          {{ loading ? $t('resetPassword.loading') : $t('resetPassword.button') }}
        </button>

        <p v-if="message" class="success">{{ message }}</p>
        <p v-if="error" class="error">{{ error }}</p>
      </form>
    </div>
  </section>
</template>

<script>
import axios from 'axios'

export default {
  name: 'ResetPassword',
  data() {
    return {
      newPassword: '',
      loading: false,
      message: '',
      error: ''
    }
  },
  computed: {
    token() {
      return this.$route.query.token
    },
    email() {
      return this.$route.query.email
    }
  },
  methods: {
      async submit() {
      this.message = ''
      this.error = ''

      const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\w\s]).{8,}$/
      if (!passwordRegex.test(this.newPassword)) {
        this.error = this.$t('resetPassword.weakPassword')
        return
      }

      this.loading = true
      try {
        const res = await axios.post('/auth/reset-password', {
          email: this.email,
          token: this.token,
          newPassword: this.newPassword
        })

        this.message = this.$t('resetPassword.successRedirect')  // i18n mesajı
        setTimeout(() => {
          this.$router.push('/login')
        }, 2000)
      } catch (err) {
        this.error = err.response?.data?.message || this.$t('resetPassword.error')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.register-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - 120px);
  padding: 40px 20px 80px;
  box-sizing: border-box;
  background: transparent;
}
.register-card {
  background: rgba(255, 255, 255, 0.9);
  padding: 32px;
  border-radius: 16px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
  width: 100%;
  max-width: 440px;
  margin-top: 40px;
}
.register-form {
  display: flex;
  flex-direction: column;
  gap: 15px;
}
.register-form input {
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #ccc;
  font-size: 14px;
}
.form-title {
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
}
.btn {
  background-color: #0c2d57;
  color: white;
  padding: 10px;
  border: none;
  border-radius: 8px;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s ease;
}
.btn:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}
.btn:hover:enabled {
  background-color: #0a2444;
}
.success {
  color: green;
  font-size: 13px;
  text-align: center;
}
.error {
  color: red;
  font-size: 13px;
  text-align: center;
}
@media (max-width: 600px) {
  .register-card {
    padding: 20px;
    border-radius: 12px;
  }
  .register-form {
    max-width: 100%;
    gap: 12px;
  }
  .register-form input,
  .btn {
    font-size: 14px;
    padding: 10px;
  }
  .form-title {
    font-size: 20px;
  }
  .success,
  .error {
    font-size: 12px;
  }
}
</style>
